





















import { Component, Vue, Prop } from 'vue-property-decorator';
import GuideGpdocShooting from '@/components/GuideGpdocShooting.vue';

@Component({
  components: {
    GuideGpdocShooting
  }
})
export default class CameraPageShootMessageGpdoc extends Vue {
  private timeoutId: number = -1;
  private isTimeout: boolean = false;

  @Prop({ type: Boolean, default: true })
  public isShow!: boolean;

  // 手動撮影で撮影済みの状態 手動撮影ではtriggerShootがtrueになったらあとはページ遷移をするので、撮影済みと同義である
  private get isManualTriggered(): boolean {
    return !this.$store.state.camera.isDetectStart && this.$store.state.camera.triggerShoot;
  }

  private get top(): number {
    return this.$store.state.camera.displayIdDocCenter;
  }

  mounted(): void {
    this.timeoutId = window.setTimeout((): void => {
      this.isTimeout = true;
    }, 3000);
  }

  beforeDestroy(): void {
    window.clearTimeout(this.timeoutId);
  }
}
